module.exports = __webpack_public_path__ + "img/marker-pin-06.cf75f69b.svg";